/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsForwardLinkListItem,
    ControlcenterMelcoControlCenterModelsForwardLinkListItemFromJSON,
    ControlcenterMelcoControlCenterModelsForwardLinkListItemFromJSONTyped,
    ControlcenterMelcoControlCenterModelsForwardLinkListItemToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsForwardLinkListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem
     */
    list: Array<ControlcenterMelcoControlCenterModelsForwardLinkListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem {
    return ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoControlCenterModelsForwardLinkListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsForwardLinkListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoControlCenterModelsForwardLinkListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


